/**
 * Same palette shape as Dispatch Calendar (`Calendar.jsx` SLOT_CHIP_PALETTE).
 * Adjust `bg` / `fg` / `hover` here to keep both calendars aligned.
 */
export const SLOT_CHIP_PALETTE = {
  morning: { bg: '#BBDEFB', fg: '#0D47A1', hover: '#90CAF9' },
  afternoon: { bg: '#FFE0B2', fg: '#BF360C', hover: '#FFCC80' },
  evening: { bg: '#E1BEE7', fg: '#4A148C', hover: '#CE93D8' },
  allDay: { bg: '#B2DFDB', fg: '#004D40', hover: '#80CBC4' },
};

/** Maps persisted / scheduler keys (ALLDAY, …) to SLOT_CHIP_PALETTE keys. */
export const SCHEDULER_SLOT_TO_PALETTE_KEY = {
  ALLDAY: 'allDay',
  MORNING: 'morning',
  AFTERNOON: 'afternoon',
  EVENING: 'evening',
};

const FALLBACK_PALETTE_KEY = 'morning';

export function resolvePaletteKey(slotKey) {
  if (!slotKey || typeof slotKey !== 'string') return FALLBACK_PALETTE_KEY;
  if (SCHEDULER_SLOT_TO_PALETTE_KEY[slotKey]) {
    return SCHEDULER_SLOT_TO_PALETTE_KEY[slotKey];
  }
  const lower = slotKey.toLowerCase();
  if (SLOT_CHIP_PALETTE[lower]) return lower;
  return FALLBACK_PALETTE_KEY;
}

export function getSlotChipColors(slotKey) {
  const k = resolvePaletteKey(slotKey);
  return SLOT_CHIP_PALETTE[k] || SLOT_CHIP_PALETTE[FALLBACK_PALETTE_KEY];
}

/** MUI `sx` for filled Chips matching Live Calendar / Dispatch Calendar slot styling. */
export function getSlotChipSx(slotKey) {
  const c = getSlotChipColors(slotKey);
  return {
    bgcolor: c.bg,
    color: c.fg,
    '&:hover': { bgcolor: c.hover },
    '& .MuiChip-label': {
      px: 0.75,
      py: 0.125,
      width: '100%',
      display: 'block',
      color: c.fg,
      fontSize: '0.7rem',
      lineHeight: 1.25,
    },
    '& .MuiChip-label .MuiTypography-root': {
      color: 'inherit',
    },
  };
}
